import sanitizeHtml from 'sanitize-html';

const SanitizeHtmlPlugin = {
  install(app, options = {}) {
    const defaultOptions = options;

    app.config.globalProperties.$sanitize = function(dirty, opts = null) {
      return sanitizeHtml(dirty, opts || defaultOptions);
    };
  },

  defaults: sanitizeHtml.defaults,
};

export default SanitizeHtmlPlugin;
